export default {
    prevalence_title: 'factsheets_screen_prevalence_title',
    incidence_title: 'factsheets_screen_incidence_title',
};
